import { styled } from "@mui/material";
import { Button, GlobalFilter } from "@volt_developers/components";
import { Trans, useTranslation } from "react-i18next";

import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";

import { TEST_IDS } from "../../../constants/TestIds";

export interface GlobalFilterSearchNoResultsProps {
  search: string;
  handleResetSearch: VoidFunction;
}

export function GlobalFilterSearchNoResults({
  search,
  handleResetSearch,
}: GlobalFilterSearchNoResultsProps) {
  const { t } = useTranslation("common");

  return (
    <GlobalFilter.Menu data-testid={TEST_IDS.globalFilterSearchNoResults}>
      <GlobalFilter.NoResults.Wrapper>
        <Header>{t(COMMON_TRANSLATION_KEYS.noResults)}</Header>
        <Description>
          <Trans t={t} components={{ strong: <Strong /> }} values={{ search }}>
            {COMMON_TRANSLATION_KEYS.noResultsFor}
          </Trans>
        </Description>
        <GlobalFilter.NoResults.Actions>
          <Button variant="outlined" onClick={handleResetSearch}>
            {t(COMMON_TRANSLATION_KEYS.resetSearch)}
          </Button>
        </GlobalFilter.NoResults.Actions>
      </GlobalFilter.NoResults.Wrapper>
    </GlobalFilter.Menu>
  );
}

const Header = styled(GlobalFilter.NoResults.Header)(({ theme }) => ({
  color: theme.palette.text.high,
}));

const Description = styled(GlobalFilter.NoResults.Description)(({ theme }) => ({
  color: theme.palette.text.high,
}));

const Strong = styled("strong")(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
}));
